import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '../../app.service';
import { ApiService } from '../../shared/api.service';
import { UtilsService } from '../../shared/utils.service';
import { ApiRequestService } from '../../shared/api-request.service';
import { AccountModel } from '../../models/account.model';

@Component({
  selector: 'app-account-hierarchy-of-controls',
  templateUrl: './account-hierarchy-of-controls.component.html',
  styleUrls: ['./account-hierarchy-of-controls.component.scss']
})
export class AccountHierarchyOfControlsComponent implements OnInit {

  @ViewChild('fileInput') fileInput: ElementRef;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public app: AppService,
    private oldApi: ApiService,
    public utils: UtilsService,
    private renderer: Renderer2,
    private api: ApiRequestService
  ) { }

  ngOnInit() {
  }

  /**
   *
   * @param evt
   *
   * Click an ion-button that in turn triggers the file input type to select a file.
   * when a file is selected, it is uploaded.
   *
   * http://pjsdev.blogspot.co.nz/2016/05/ionic-2-beta-6-angular-2-styled-upload.html
   */
  onTriggerFileSelector(evt: Event) {
    if(this.fileInput) {
      const clickEvt: MouseEvent = new MouseEvent('click', { bubbles: true });
      this.fileInput.nativeElement.dispatchEvent(clickEvt);
    }
  }

  // When a file is selected, store it.
  onUploadSelectedFile(evt: any) {
    this.api.makeUploadRequest('v1/account/company-hierarchy-of-controls', evt.target.files[0])
      .then((response) => {
        this.app.account = new AccountModel().apply(response);
        this.utils.showToast("Your company's hierarchy of controls was updated.");
      })
      .catch((errorResponse) => {
        this.utils.handleAPIErrors(errorResponse);
      });
  }

  onRemoveCompanyHierarchyOfControls() {
    this.api.makeRequest('delete', 'v1/account/company-hierarchy-of-controls')
      .then((response) => {
        this.app.account = new AccountModel().apply(response);
        this.utils.showToast("Your company's hierarchy of controls was removed.");
      })
      .catch((errorResponse) => {
        this.utils.handleAPIErrors(errorResponse);
      });
  }

}
